export default function({ store, redirect, route }) {
  if (!store.state.auth.loggedIn) {
    let fullPath = route.fullPath;
    return redirect(307, `/enter/login?ReturnUrl=${fullPath}`);
  }
}
